import React, { useEffect, useState } from "react";
import { ListChecks, CheckCircle2, Layers, Tags, BarChart3 } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) {
    return <div className="flex h-64 items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-4 border-dh-red border-t-transparent" /></div>;
  }

  const kpis = [
    { label: "Questions totales", value: stats.total_questions, icon: ListChecks, color: "bg-dh-red/10 text-dh-red" },
    { label: "Questions actives", value: stats.active_questions, icon: CheckCircle2, color: "bg-dh-green/10 text-dh-green" },
    { label: "Catégories", value: `${stats.active_categories}/${stats.total_categories}`, icon: Layers, color: "bg-dh-blue/10 text-dh-blue" },
    { label: "Tags", value: stats.total_tags, icon: Tags, color: "bg-dh-gold/10 text-dh-gold" },
  ];

  const maxCat = Math.max(1, ...stats.per_category.map((c) => c.count));

  return (
    <div className="mx-auto max-w-7xl space-y-8">
      <div>
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Tableau de bord</h1>
        <p className="text-sm text-slate-500">Statistiques dynamiques du contenu.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {kpis.map((k) => (
          <div key={k.label} data-testid={`kpi-${k.label}`} className="rounded-2xl border border-slate-200 bg-white p-5">
            <div className={`mb-3 flex h-10 w-10 items-center justify-center rounded-xl ${k.color}`}><k.icon className="h-5 w-5" /></div>
            <div className="font-display text-3xl font-extrabold">{k.value}</div>
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">{k.label}</div>
          </div>
        ))}
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="mb-4 flex items-center gap-2 font-display text-lg font-bold uppercase"><BarChart3 className="h-5 w-5 text-dh-red" /> Questions par catégorie</div>
          <div className="space-y-3">
            {stats.per_category.map((c) => (
              <div key={c.id}>
                <div className="mb-1 flex items-center justify-between text-sm">
                  <span className="font-semibold">{c.name} {!c.active && <span className="text-xs text-slate-400">(inactive)</span>}</span>
                  <span className="text-slate-500">{c.count}</span>
                </div>
                <div className="h-2 overflow-hidden rounded-full bg-slate-100">
                  <div className="h-full rounded-full bg-dh-red" style={{ width: `${(c.count / maxCat) * 100}%` }} />
                </div>
              </div>
            ))}
            {stats.per_category.length === 0 && <p className="text-sm text-slate-400">Aucune catégorie.</p>}
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="mb-4 flex items-center gap-2 font-display text-lg font-bold uppercase"><BarChart3 className="h-5 w-5 text-dh-red" /> Questions par difficulté</div>
          <div className="space-y-3">
            {stats.per_difficulty.map((d) => (
              <div key={d.difficulty} className="flex items-center justify-between rounded-xl border border-slate-100 bg-slate-50 px-4 py-3">
                <span className="font-semibold">{d.difficulty}</span>
                <span className="font-display text-xl font-extrabold text-dh-red">{d.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
